// Content endpoints
export const CONTENT = {
  LIST: '/api/content',
  GET: (id: string) => `/api/content/${id}`,
  ANALYZE: (id: string) => `/api/content/${id}/analyze`,
  MARK_IMPORTANT: (id: string) => `/api/content/${id}/important`,
  DELETE: '/api/content',
  SCRAPE_URL: '/api/content/scrape-url',
  UPDATE: (id: string) => `/api/content/${id}`,
  UPDATE_LANGUAGE: (id: string) => `/api/content/${id}/language`,
  FETCH_RSS: '/api/content/fetch-rss'
}

// Institution endpoints
export const INSTITUTIONS = {
  LIST: '/api/institutions',
  GET: (id: string) => `/api/institutions/${id}`,
  CREATE: '/api/institutions',
  UPDATE: (id: string) => `/api/institutions/${id}`,
  DELETE: (id: string) => `/api/institutions/${id}`,
  IMPORT: '/api/institutions/import',
  PREVIEW: '/api/institutions/preview',
  EXPORT: '/api/institutions/export',
  TEMPLATE: '/api/institutions/template'
}

// Email endpoints
export const EMAILS = {
  LIST: '/api/emails',
  APPROVE: (id: string) => `/api/emails/${id}/approve`,
  APPROVE_BULK: '/api/emails/approve-bulk',
  IMPROVE: (id: string) => `/api/emails/${id}/improve`,
  DELETE: (id: string) => `/api/emails/${id}`,
  GENERATE: '/api/emails/generate',
  UPDATE: (id: string) => `/api/emails/${id}`
}

// Follow-ups endpoints
export const FOLLOW_UPS = {
  LIST: '/api/follow-ups',
  RECOMMENDATIONS: '/api/follow-ups/recommendations',
  PROCESS_BULK: '/api/follow-ups/recommendations/process-bulk',
  GET: (id: string) => `/api/follow-ups/${id}`,
  CREATE: '/api/follow-ups',
  UPDATE: (id: string) => `/api/follow-ups/${id}`,
  DELETE: (id: string) => `/api/follow-ups/${id}`,
  COMPLETE: (id: string) => `/api/follow-ups/${id}/complete`,
  CANCEL: (id: string) => `/api/follow-ups/${id}/cancel`,
  SKIP: (id: string) => `/api/follow-ups/skip/${id}`,
  RESCHEDULE: (id: string) => `/api/follow-ups/reschedule/${id}`,
  MANUAL: '/api/follow-ups/manual'
} 